import { useGenerateSeoTags } from '@components/ArtBoard/ProjectToolbar/hooks/useGenerateSeoTags'
import { ChartSimpleAi, LanguageAi } from '@octopus-do/octopus-storybook/icons'
import { AIActions } from '@store/reducers/ai'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { ActionButton, ActionsMessage } from '../../../index'

export const MainActionsMessage: React.FC = () => {
  const dispatch = useDispatch()
  const generateSeo = useGenerateSeoTags()

  const onSeoClick = () => {
    generateSeo()
  }

  const onTranslateClick = () => {
    dispatch(
      AIActions.addMessage({
        message: {
          type: 'actions',
          buttons: 'translate',
        },
      })
    )
  }

  return (
    <ActionsMessage>
      <ActionButton
        icon={<ChartSimpleAi />}
        variant="purple"
        onClick={onSeoClick}
      >
        Generate SEO tags
      </ActionButton>
      <ActionButton
        icon={<LanguageAi />}
        variant="purple"
        onClick={onTranslateClick}
      >
        Translate to...
      </ActionButton>
    </ActionsMessage>
  )
}
